import * as Yup from 'yup';

export const SIGNIN_VALIDATION_SCHEMA = Yup.object({
	username: Yup.string().required('Username is required.'),
	password: Yup.string().required('Password is required.'),
});
